import { useEffect, useState } from 'react';
import { Admin, AdminsResponse } from '../../shared';
import { isType } from '../../shared';
import { fetchAdmins, UseAssessments } from './models';


export const useAssessments = (isLoggedIn: boolean): UseAssessments => {

  const [assessments, setAssessments] = useState<Admin[]>([]);
  const [assessmentsLoading, setAssessmentsLoading] = useState<boolean>(false);

  useEffect(() => {
    const controller = new AbortController();
    let mounted = true;

    const processfetchAdmins = async() => {
      setAssessmentsLoading(true);
      const response = await fetchAdmins(controller);
      if (mounted) {
        if (isType<AdminsResponse>(response, 'AdminsResponse')) {
          setAssessments(response.admins);
        }
        setAssessmentsLoading(false);
      }
    };

    if (isLoggedIn) {
      processfetchAdmins();
    }

    return () => {
      controller.abort();
      mounted = false;
    };
  }, [isLoggedIn]);

  return {assessments, assessmentsLoading};
};

export default useAssessments;